import { Layout } from 'antd';

const { Footer: Foot } = Layout;

function Footer() {
  return (
    <Foot
      style={{
        textAlign: 'center',
        backgroundColor: '#fff',
        padding: '10px',
      }}
    >
      MySG ©2024 byes-eco-gestes-web
    </Foot>
  );
}

export default Footer;
